
























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import {District, Ward} from "@/interfaces/entity";
import {RegionStore} from "@/modules/regions/store";
import WardLabel from "@/modules/regions/WardLabel/index.vue";
import {toSlug} from "@/shared/services/helper/utils";

@Component({
    name: "WardSelector",
    components: {WardLabel}
})
export default class extends Vue {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';


    @Model("change", {type: Number})
    readonly wardId!: number;

    @Emit("change")
    handleChange(value?: number) {
        const ward = this.wards.find((ward: Ward) => ward.id === value);
        this.$emit("ward", ward);
        return value;
    }

    @Prop({required: true})
    readonly districtId!: number;

    wards: Ward[] = [];

    @Watch("districtId", {immediate: true})
    async onChangeDistrictId(val: number, oldVal: number) {
        if (!val && !oldVal) return;
        if (!val && oldVal) {
            this.wards = [];
            this.handleChange();
            return;
        }
        try {
            this.wards = await RegionStore.getWards(val);
            if (!this.wardId) return;
            if (this.wards.some((ward: Ward) => ward.id === this.wardId)) return;
            this.handleChange();
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: e?.response?.data?.message || "Đã có lỗi xảy ra"
            });
        }
    }

    get wardIds(): number[] {
        return RegionStore.wardIds;
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ").toLowerCase()) >= 0);
    }
}
